//================= [JS] ==========================
import {BaseApi} from '@/common/api/BaseApi';
import {ApiProperties} from '@/types/common/api/api.types';
//================= [EXTERNAL JS] =================

//================= [CLASS] =======================

export class AppBetaApi {

  public static api({version = 'v1'}: ApiProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/app-beta`;
  }

}
